<template>
  <!-- Contact Section start -->
  <section id="contact" class="contact" style="padding-bottom: 0;">
    <div class="contact-decor">
      <div class="contact-circle1"><img :src='"../assets/images/main-banner12.png"' alt=""></div>
      <div class="contact-circle2"><img :src='"../assets/images/main-banner1.png"' alt=""></div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-lg-8 col-sm-12">
          <div class="contact-us">
            <div class="w-100">
              <h2 class="title"><span>SEJA UM </span>PARCEIRO</h2>
              <h6>
                Venha para a Família Prodo Sistemas, e tenha acesso a todos os benefícios que somente
                nossos parceiros possuem.
                Faça seu cadastro que entraremos em contato para lhe passar todos os benefícios de
                ser um parceiro Prodo!
              </h6>
              <form id="myform" class="theme-form" @submit.prevent="sendEmail">
                <div class="form-group">
                  <div class="row">
                    <div id="mail_alert_class" class="alert alert-success alert-dismissible d-none">
                      <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                      <div id="alert_mail">

                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12 col-md-4 md-fgrup-margin">
                      <the-mask type="text" class="form-control" 
                      :class="resale.cnpj == '' || resale.cnpj.length > 11 ? '' : 'error'"
                      v-model="resale.cnpj" 
                      id="cnpj"
                      name="cnpj" 
                      placeholder="CNPJ/CPF*"
                      :mask="['###.###.###-##', '##.###.###/####-##']" 
                      key="1"
                      minlength="18"
                      :masked="true" 
                      required="required"/>
                    </div>
                    <div class="col-sm-12 col-md-4 md-fgrup-margin">
                      <input type="text" class="form-control" v-model="resale.name" name="fullname"
                        placeholder="Responsável*" required="required">
                    </div>
                    <div class="col-sm-12 col-md-4">
                      <the-mask type="tel" class="form-control"
                      v-model="resale.phone" 
                      name="phone" 
                      placeholder="Celular"
                      :mask="'+55 (##) #.####-####'" 
                      key="2"
                      :masked="true" />
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <input type="email" class="form-control" 
                  v-model="resale.email" 
                  id="email" placeholder="E-mail*"
                    required="required">
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-sm-12 col-md-8 md-fgrup-margin">
                      <input type="text" class="form-control" 
                      v-model="resale.address" placeholder="Endereço: Rua, nº 0">
                    </div>
                    <div class="col-sm-12 col-md-4 md-fgrup-margin">
                      <input type="text" class="form-control" v-model="resale.city" placeholder="Cidade">
                    </div>
                  </div>
                </div>
                <div class="form-group form-button">
                  <input type="submit" id="emailsend" name="send" class="btn btn-custom theme-color"
                    value="Enviar Cadastro" />
                </div>
                <div>
                  <b-alert
                    :show="dismissCountDown"
                    dismissible
                    :variant="alert.color"
                    @dismissed="dismissCountDown=0"
                    @dismiss-count-down="countDownChanged"
                    class="d-flex justify-content-between"
                  >
                   <span>{{alert.text}}</span> <small>{{ dismissCountDown }} seconds...</small>
                  </b-alert>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-lg-4 d-medium-none-lg">
          <div class="contact-right">
            <img :src='"../assets/images/Parceiro.png"' class="img-fluid" alt="">
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Contact Section End -->
</template>
<script>
import emailjs from 'emailjs-com';
export default {
  name: 'Contact_us',
  data() {
    return {
      reset: {
        cnpj: '',
        name: '',
        phone: '',
        email: '',
        address: '',
        city: ''
      },
      alert: {
        color: '',
        text: ''
      },
      alertTypes: {
        success: {
          color: 'success',
          text: 'Formulario enviado com sucesso!'
        },
        invalid: {
          color: 'danger',
          text: 'Campo CPF/CNPJ invalido!'
        },
        error: {
          color: 'danger',
          text: 'Não foi possivel enviar seus dados'
        }
      },
      resale: {},
      dismissSecs: 5,
      dismissCountDown: 0
    }
  },
  created() {
    this.resale = { ...this.reset  }
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    sendEmail(e) {
      let btn = document.getElementById("emailsend")
      if (this.resale.cnpj.length < 11){
        let cnpj = document.getElementById("cnpj")
        cnpj.focus()
        cnpj.classList.add("error");
        this.alert = this.alertTypes.invalid
          this.showAlert()
      }else{
        btn.disabled = true;
        emailjs.send('service_86xi8wo', 'template_mp6a8ng', this.resale,'SAoyYgFb-AYXupNN6')//jbBnYe8QNoGfdQ-b-7
        .then((value) => {
          this.resale = { ...this.reset  }
          this.alert = this.alertTypes.success
          this.showAlert()
          setTimeout(() => {            
            btn.disabled = false;
          }, 5000);
        })
        .catch((error) => {
          this.alert = this.alertTypes.error
          this.showAlert()
          setTimeout(() => {            
            btn.disabled = false;
          }, 5000);
        });
      }

    },
  }
}
</script>
<style scoped>
@media (max-width: 1366px){
.contact-right {
    width: 240px;
}
}

@media (min-width: 1400px) {
.contact-right {
    width: 455px;
}
}
.theme-form .form-control {
  box-shadow: 0 0 5px 0 rgb(170 170 170 / 59%) ;
}
.error {
  background-color: #fe00003b !important;
  box-shadow: 0 0 5px 0px #ff0000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/contact_us.vue